module.exports = __webpack_public_path__ + "img/logo-zc.0e0c0c5a.webp";